// extracted by mini-css-extract-plugin
export default {"wrapAddress":"AddressField_wrapAddress__ySkKs","address":"AddressField_address__wxS9t","txtInfo":"AddressField_txtInfo__ejY0G","accentTxt":"AddressField_accentTxt__46pA6"};